import i18n from './i18n';

const RECENT_LS_KEY = 'casinoRecentSearch';
export const FAVORITE_LS_KEY = 'casinoFavorite';

export const getRecentGamesFromLS = () => JSON.parse(localStorage.getItem(RECENT_LS_KEY) || '[]');

export const addRecentGameToLS = game => {
  let games = getRecentGamesFromLS();

  if (games.find(g => g.display_name === game.display_name)) return;

  if (games.length >= 12) {
    games.shift();
    games = [...games, game];
  } else {
    games = [...games, game];
  }

  localStorage.setItem(RECENT_LS_KEY, JSON.stringify(games));
};

export const getFavoriteGamesFromLS = () => JSON.parse(localStorage.getItem(FAVORITE_LS_KEY) || '[]');

export const favoriteMenuItem = games => ({
  id: 222,
  display_name: i18n.t('Favorites'),
  image: '',
  isActive: true,
  icon: 'favorites-menu',
  most_played_games: [],
  games,
});
